module.exports = __webpack_public_path__ + "img/Giti_background.fdba9707.png";